import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useSelector } from "react-redux";

import {
  FormControl,
  TextField,
  OutlinedInput,
  FormHelperText,
  InputLabel,
  Alert,
  Typography,
} from "@mui/material";

import {
  validarCelular,
  validarFalsaData,
} from "app/modules/shared/validations/validaciones";

import {
  consultaContacto,
  crearClienteContacto,
  consultarCodigoProvincia,
} from "../services/clienteService";

import {
  MaskCelulares,
  MaskTelefonos,
} from "app/modules/shared/mask/mascarasInputs";

import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";
import { StyleInputs } from "../styles/themes";
import SkeletonForm from "app/modules/common/components/Skeleton/SkeletonForm";

import { ERROR_VALIDACION_CONTACTO } from "app/modules/shared/constants/constantsMessanges";
import SelectItemsCatalogs, {
  SelectItemsCatalogsSpecial,
} from "app/modules/common/components/Selector";

const FormContactoCliente = ({
  idCliente,
  tipoDireccion,
  setInfoClienteGrabada,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const [clienteInfo, setClienteInfo] = useState(null);
  const [controlExpand, setControlExpand] = useState({
    controlExpanded: true,
    controlSave: false,
  });

  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);
  const [codigoProvincia, setCodigoProvincia] = useState("00");
  const [isLoading, setIsLoading] = useState(true);
  const [idContactonAux, setIdContactoAux] = useState(0);

  useEffect(() => {
    const getData = async () => {
      let infoContacto;

      const contacto = JSON.parse(localStorage.getItem("contacto"));

      try {
        const informacionContacto = await consultaContacto(
          idCliente,
          tipoDireccion ?? "DIRDOM"
        );

        if (informacionContacto.state) {
          infoContacto = informacionContacto?.data;

          setCodigoProvincia(informacionContacto?.data?.telefono?.slice(0, 2));

          setIdContactoAux(informacionContacto?.data?.idContacto);
        } else {
          contacto === null
            ? (infoContacto = {})
            : (infoContacto = {
                celular: "",
                email: "",
                telefono: "",
              });
        }
        setClienteInfo(infoContacto);
      } catch (error) {
        contacto === null
          ? (infoContacto = {})
          : (infoContacto = {
              celular: "",
              email: "",
              telefono: "",
            });
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, [idContactonAux]);

  if (isLoading) {
    return <SkeletonForm />;
  }

  if (idCliente <= 0) {
    return <h2>Cliente NO existe. Primero cree el Cliente.!!</h2>;
  }

  const CodigoProvincia = ({ provincia }) => {
    const [codProvincia, setCodProvincia] = useState(codigoProvincia);
    useEffect(() => {
      const getCodigoProvincia = async () => {
        try {
          const respuestaCodigoProvincia = await consultarCodigoProvincia(
            provincia
          );

          if (respuestaCodigoProvincia.state) {
            setCodigoProvincia(
              respuestaCodigoProvincia?.data?.codigoTelefonico
            );
            setCodProvincia(respuestaCodigoProvincia?.data?.codigoTelefonico);
          } else {
            setCodigoProvincia("00");
            setCodProvincia("00");
          }
        } catch (error) {
          console.log(error);
        }
      };
      if (
        provincia !== "" &&
        provincia !== undefined &&
        provincia !== null &&
        provincia > 0 &&
        provincia !== "0"
      ) {
        getCodigoProvincia();
      }
    }, [provincia]);

    return (
      <TextField
        disabled
        id="codigo"
        name="codigo"
        type="text"
        label="COD"
        value={codProvincia}
        size="small"
        sx={StyleInputs(15, 20)}
      />
    );
  };

  const validarTelefono = (telefono) => {
    if (!telefono) {
      return false;
    } else {
      return telefono?.slice(-7);
    }
  };

  const configuracionDatosEnvio = async (valoresAux, setSubmitting) => {
    setSubmitting(true);

    const today = new Date().toLocaleString("en-US");

    const valores = { ...valoresAux };
    if (valoresAux.telefono === "") {
      valores.telefono = "";
    } else {
      valores.telefono = codigoProvincia + valores.telefono;
    }

    const informacionContacto = {
      idCliente: idCliente,
      idContacto: idContactonAux,

      celular: valores?.celular,
      email: valores.email.toLowerCase(),
      telefono: valores.telefono,
      telefono2: valores.telefono2,
      extension: valores.extension,
      tipoDireccion: tipoDireccion ?? "DIRDOM",
      preferencia: valores.preferencia,
      esPersonal: true,
      esActivo: true,

      fechaCreacion: today,
      usuarioCreacion: authUser.key,
      estacionCreacion: authUser.estacion,
    };

    try {
      const respuestaClienteContacto = await crearClienteContacto(
        informacionContacto
      );

      if (respuestaClienteContacto.state) {
        setIdContactoAux(respuestaClienteContacto.data);

        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            ubicabilidad: true,
          }));
        }
        setDatosEnviadosCorrectamente(true);

        setTimeout(() => {
          setSubmitting(false);
          setDatosEnviadosCorrectamente(false);
          handleExpand();
          setControlExpand((args) => ({
            ...args,
            controlSave: true,
          }));
        }, 1000);
      } else {
        alert(`${respuestaClienteContacto.message}`);
      }
    } catch (error) {
      alert(`${error?.response?.data?.message}`);

      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleExpand = () => {
    setControlExpand((args) => ({
      ...args,
      controlExpanded: !args.controlExpanded,
    }));
  };

  return (
    <Formik
      initialValues={{
        idUbicGeografica1: "",
        celular: clienteInfo?.celular || "",
        email: clienteInfo.email || "",
        telefono: validarTelefono(clienteInfo.telefono) || "",
        telefono2: clienteInfo.telefono2 || "",
        extension: clienteInfo.extension || "",
        preferencia: clienteInfo.preferencia || "",
      }}
      validate={async (values) => {
        const errors = {};

        if (!/^[0-9]{0,11}$/.test(values.telefono)) {
          errors.telefono = "Solo se aceptan números";
        }

        if (!/^[0-9]{0,11}$/.test(values.extension)) {
          errors.extension = "Solo se aceptan números";
        }

        if (!/^[0-9]{0,11}$/.test(values.telefono2)) {
          errors.telefono2 = "Solo se aceptan números";
        }
        if (validarCelular(values.telefono2)) {
          errors.telefono2 = "Primer digito debería ser '09'";
        }

        if (await validarFalsaData(values.celular, "CEL")) {
          errors.celular = ERROR_VALIDACION_CONTACTO;
        }

        if (await validarFalsaData(values.telefono2, "CEL")) {
          errors.telefono2 = ERROR_VALIDACION_CONTACTO;
        }

        if (!/^[0-9]{0,11}$/.test(values.celular)) {
          errors.celular = "Solo se aceptan números";
        }

        if (validarCelular(values.celular)) {
          errors.celular = "Primer digito debería ser '09'";
        }

        if (await validarFalsaData(values.email, "COR")) {
          errors.email = "Data invalida";
        }

        return errors;
      }}
      validationSchema={Yup.object({
        celular: Yup.string()
          .min(10, "Debería tener 10 números")
          .max(10, "Debería tener 10 números")
          .required("Celular requerido"),
        telefono: Yup.string()
          .min(7, "Debería tener 7 números")
          .max(7, "Debería tener 7 números"),
        telefono2: Yup.string()
          .min(10, "Debería tener 10 números")
          .max(10, "Debería tener 10 números"),
        extension: Yup.string()
          .min(1, "Debería tener 1 números")
          .max(10, "Excede número de caracteres"),

        email: Yup.string().email("Email no tiene formato"),
        preferencia: Yup.string().required("Preferencia requerida"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        configuracionDatosEnvio(values, setSubmitting);
      }}
    >
      {({
        values,
        handleChange,
        touched,
        errors,
        handleBlur,
        isSubmitting,
      }) => (
        <Form>
          <SCSAccordion
            tituloCabecera="Información Contacto "
            controlExpand={controlExpand}
            handleExpand={handleExpand}
          >
            <div>
              <h3>Contacto</h3>
              <Alert severity="info">
                <Typography
                  sx={{
                    fontSize: "1rem",
                    "@media (max-width: 450px)": {
                      fontSize: "0.85rem",
                    },
                  }}
                >
                  Ingresa tu celular y email para notificacion.
                </Typography>
              </Alert>
            </div>

            <div className="cliente-informacion-seccion">
              <FormControl
                sx={StyleInputs(15, 45)}
                size="small"
                variant="outlined"
                error={touched.celular && Boolean(errors.celular)}
                helperText={touched.celular && errors.celular}
                onBlur={handleBlur}
              >
                <InputLabel htmlFor="celular">Celular</InputLabel>
                <OutlinedInput
                  value={values.celular}
                  onChange={handleChange}
                  name="celular"
                  id="celular"
                  inputComponent={MaskCelulares}
                  label="celular"
                />
                <ErrorMessage
                  name="celular"
                  component={() => (
                    <FormHelperText>{errors.celular}</FormHelperText>
                  )}
                />
              </FormControl>

              <TextField
                id="email"
                name="email"
                type="text"
                label="Email para notificaciones"
                sx={StyleInputs(30, 95)}
                value={values.email}
                onChange={handleChange}
                size="small"
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
                onBlur={handleBlur}
              />

              <FormControl
                sx={StyleInputs(15, 45)}
                size="small"
                variant="outlined"
                error={touched.telefono2 && Boolean(errors.telefono2)}
                helperText={touched.telefono2 && errors.telefono2}
                onBlur={handleBlur}
              >
                <InputLabel htmlFor="telefono2">Celular 2</InputLabel>
                <OutlinedInput
                  value={values.telefono2}
                  onChange={handleChange}
                  name="telefono2"
                  id="telefono2"
                  inputComponent={MaskCelulares}
                  label="telefono2"
                />
                <ErrorMessage
                  name="telefono2"
                  component={() => (
                    <FormHelperText>{errors.telefono2}</FormHelperText>
                  )}
                />
              </FormControl>

              {/* Preferecia */}

              <SelectItemsCatalogs
                pais="ECU"
                especial="false"
                catalogos="TIPOCOM"
                grupo={1}
                name="preferencia"
                labelName="Preferencia"
                componentSize={{ pcWidth: 15, phoneWidth: 46 }}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </div>

            <div
              style={{
                borderRadius: "10px",
                backgroundColor: "#f1f1f1",
                padding: "1rem",
                margin: "0.6rem 0",
              }}
            >
              <section className="contactoCliente-telefono">
                <SelectItemsCatalogsSpecial
                  pais="ECU"
                  especial="true"
                  catalogos="UG1"
                  codPadre={0}
                  grupo={1}
                  name="idUbicGeografica1"
                  labelName="Provincia"
                  componentSize={{ pcWidth: 30, phoneWidth: 70 }}
                  handleBlur={handleBlur}
                  touched={touched}
                  errors={errors}
                />

                <CodigoProvincia provincia={values.idUbicGeografica1} />

                <FormControl
                  sx={StyleInputs(20, 55)}
                  size="small"
                  variant="outlined"
                  error={touched.telefono && Boolean(errors.telefono)}
                  helperText={touched.telefono && errors.telefono}
                  onBlur={handleBlur}
                >
                  <InputLabel htmlFor="telefono">Télefono</InputLabel>
                  <OutlinedInput
                    value={values.telefono}
                    onChange={handleChange}
                    name="telefono"
                    id="telefono"
                    inputComponent={MaskTelefonos}
                    label="telefono"
                  />
                  <ErrorMessage
                    name="telefono"
                    component={() => (
                      <FormHelperText>{errors.telefono}</FormHelperText>
                    )}
                  />
                </FormControl>

                <TextField
                  id="extension"
                  name="extension"
                  type="text"
                  label="Extensión"
                  inputProps={{ min: 0 }}
                  sx={StyleInputs(18, 35)}
                  value={values.extension}
                  onChange={handleChange}
                  size="small"
                  error={touched.extension && Boolean(errors.extension)}
                  helperText={touched.extension && errors.extension}
                  onBlur={handleBlur}
                />
              </section>
            </div>

            <div className="confirmar-estados-servicios">
              <SCSLoadingButton
                type="submit"
                loading={isSubmitting}
                titulo="GUARDAR"
              />

              {datosEnviadosCorrectamente && <AcceptServiceresponse />}
            </div>
          </SCSAccordion>
        </Form>
      )}
    </Formik>
  );
};

export default FormContactoCliente;
